module.exports = __webpack_public_path__ + "static/media/event-services-img47.10b2109b.jpg";